import React from 'react'
import { useIntl } from 'react-intl'
import Button from './index'

const SaveButton = ({ onClick, isDisabled, btnText, btnClass }) => {
  const { formatMessage: msg } = useIntl()

  return (
    <Button
      btnText={msg({ id: btnText || 'button.save' })}
      iconRight
      iconClass="pi pi-save"
      iconSize="1rem"
      btnType="button"
      btnClass={btnClass}
      isDisabled={isDisabled}
      onHandleClick={onClick}
    />
  )
}

export default SaveButton
